export const apiURL = `${process.env.REACT_APP_API_URL}`;
export const bankProfileUrl = `${process.env.REACT_APP_BANK_PROFILE_URL}`;

export const getVerificationList = apiURL + "/api/User/registration/";
export const rejectionList = apiURL + "/api/User/rejection/";
export const getUploadUrl = apiURL + "/api/User/documents/registration/";
export const getUploadRejectUrl = apiURL + "/api/User/documents/rejected/";
export const getAllCommentListById = apiURL + "/api/User/usercomments/"; //TODO -comments in production
export const addUserComment = apiURL + "/api/User/usercomment/"; //TODO -comments to production
export const approveRegistrations = apiURL + "/api/User/approve-registration/";
export const rejectRegistrations = apiURL + "/api/User/reject-registration/";
export const rejectReason = apiURL + "/api/Lookup/reject-reasons/";
export const getCardStatus = apiURL + "/api/User/";

/**
 * Token revocation api url to make inactive the token after logout.
 */
export const tokenRevocationUrl =
  "https://sso.sbx.edenred.io/connect/revocation";

export const getAtmPinNonRegisterUrl = apiURL + "/api/CardHolder/pin";

//? RAK- BE
export const getAllRakBeneficiaryList =
  apiURL + "/api/MoneyTransfer/beneficiaries";
export const getConformationDetails =
  apiURL + "/api/MoneyTransfer/approve-beneficiary/";
export const getDropdownTypeList = apiURL + "/api/User/dd";
export const getDropdownCountryList = apiURL + "/api/Lookup/country/";
export const getDropdownStatusList = apiURL + "/api/User/dd";
export const getDropdownTypeListDD = apiURL + "/api/User/dd";
export const getBankDetailByBeneficiaryId = apiURL + "/api/User/dd/";

//? RECHARGE -BENEFICIARY_TABLE

export const getAllRechargeBeneficiaryList =
  apiURL + "​/api/MobileRecharge/beneficiaries";

//? VAS- SERVICES

export const getPortalUser = apiURL + "/api/PortalUsers/";

// ? MONEY TRANSFER BENEFICIARY - rakbeneficiary

export const getTabBankDetailsList =
  apiURL + "/api/MoneyTransfer/beneficiary-bankdetails/";
export const getTabRakBeneficiaryList =
  apiURL + "/api/MoneyTransfer/beneficiaries/";
export const deleteUser = apiURL + "/api/MoneyTransfer/beneficiary/";
export const approveBeneficiary =
  apiURL + "/api/MoneyTransfer/approve-beneficiary/";
export const sentConfirmationById =
  apiURL + "/api/MoneyTransfer/approve-beneficiary/";
export const getTabC3toC3BeneficiaryList =
  apiURL + "/api/MoneyTransfer/c3toc3beneficiaries/";

//rakTransaction
export const getTabRakTransactionsList =
  apiURL + "/api/Transaction/moneytransfer-beneficiaries-transaction/";
export const getRakTransactionReceiptById =
  apiURL + "/api/Transaction/moneytransfertransaction-receipt/";
export const updateTransactionStatus =
  apiURL + "/api/Transaction/moneytransfertransaction-receipt-status/";

export const transactionRevrse = (referenceNumber) =>
  apiURL +
  `/api/transaction/moneytransfertransaction/${referenceNumber}/reverse`;

export const transactionMarkSuccess = (referenceNumber) =>
  apiURL +
  `/api/transaction/moneytransfertransaction/${referenceNumber}/success`;

export const getTabC3toC3TransactionList =
  apiURL + "/api/Transaction/moneytransfer-c3toc3-beneficiaries-transaction/";
//rechargebeneficiary
export const getTabRechargeBeneficiaryList =
  apiURL + "/api/MobileRecharge/beneficiaries/";
export const getTabC3BeneficiaryList =
  apiURL + "/api/MoneyTransfer/c3toc3beneficiaries/";

//rechargeTransaction
export const getTabRechargeTransactionsList =
  apiURL + "/api/Transaction/recharge-beneficiaries-transaction/";
export const getTabRechargeTransactionsDetails =
  apiURL + "/api/Transaction/mobilerechargetransaction-receipt/";
export const deleteMobileRecharge = apiURL + "/api/MobileRecharge/beneficiary/";

//? subscription
export const getSubscriptionDetails = apiURL + "/api/Subscription/";
export const subscriptionSave = apiURL + "/api/Subscription/";

//? Biller
export const getBillerList = apiURL + "/api/BillPayment/user/billers/";
export const deleteBillerList = apiURL + "/api/BillPayment/user/biller/";
export const getCountry = apiURL + "/api/Lookup/country/";

//? Bill Payments
export const getBillpayementList =
  apiURL + "/api/BillPayment/user/bill-payments/";

// ? USER-DETAILS
export const unblockUser = apiURL + "/api/User/unblock/";
export const blockUser = apiURL + "/api/User/block/";
export const activateCard = apiURL + "/api/User/activate-card/";
export const blockReason = apiURL + "/api/Lookup/block-reasons";
export const getuserProfileDetailById = apiURL + "/api/User/profile/";
export const removeUserAccount = apiURL + "/api/User/remove/";
export const sendPassword = apiURL + "/api/User/reset/password/";
export const updateEIDNumber = apiURL + "/api/User/update-eid-number/";
export const viewKyc = apiURL + "/api/User/documents/all/";
export const enableSelfieBypass = apiURL + "/api/user/selfie-bypass/enable";
export const disableSelfieBypass = apiURL + "/api/user/selfie-bypass/disable";

// Rak Profile Creation History
export const getCreationHistory = bankProfileUrl + "/profile/history/";
//export const getCreationHistory = apiURL + "/api/User/rmt-profile-history/";